import React, {Fragment} from 'react'
import { Link } from 'react-router-dom'

const priceContent = [
    {
       packName: '기본 보안 점검',
       desc: '중소기업을 위한 핵심 보안 진단 및 기본 보호 조치',
       price: '협의',
       month: '/프로젝트',
       feature: [
            'OWASP 취약점 점검',
            '서버 보안 설정 검토',
            '보안 리포트 제공',
            '1회 기술 상담',
            '조치 가이드 제공'
       ],
       dataAos:'fade-left',
       dataDelay:'50',
    },
    {
       packName: '엔터프라이즈 보안',
       desc: '기업 인프라 전반의 종합 보안 구축 및 운영',
       price: '협의',
       month: '/프로젝트',
       feature: [
            '웹·서버·클라우드 보안',
            '접근 권한 관리 구축',
            '데이터 보호 설계',
            '정기 취약점 점검',
            '24/7 보안 모니터링'
       ],
       dataAos:'fade-left',
       dataDelay:'100',
    },
    {
       packName: '보안 운영 관리',
       desc: '지속적인 보안 유지 및 컴플라이언스 대응',
       price: '협의',
       month: '/월',
       feature: [
            'ISMS·GDPR 컴플라이언스',
            '월간 보안 점검',
            '인시던트 대응',
            '임직원 보안 교육',
            '전담 보안 담당자 배정'
       ],
       dataAos:'fade-left',
       dataDelay:'150',
    },
]

const YearlyPrice = () => {
    return (
        <Fragment>
            <div className="row gx-4 gx-xxl-5 justify-content-center">
                {priceContent.map((val,i)=>(
                    <div key={i} className="col-lg-4 col-md-6" data-aos="fade-left" data-aos-delay={100}>
                        <div className="plan mb-45">
                            <div className="plan__header">
                                <h3>{val.packName}</h3>
                                <p>{val.desc}</p>
                                <h2>{val.price}<span>{val.month}</span></h2>
                            </div>
                            <ul className="plan__feature list-none">
                                {val.feature.map((f, j)=>(
                                    <li key={j}><i className="bi bi-check2"/>{f}</li>
                                ))}
                            </ul>
                            <Link className="theme_btn w-100 text-center" to="/contact">상담 신청하기</Link>
                        </div>
                    </div>
                ))}
            </div>
        </Fragment>
    )
}

export default YearlyPrice
